import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import { useNavigate, useParams } from "react-router-dom";
import { useRecoilState } from "recoil";
import QRCodeScreen from "./QRCodeScreen";
import UserList from "./UserList";
import AsyncLocalStorage from "../../util/AsyncLocalStorage";
import ShareSetting from "./ShareSetting";
import UserController from "../../controller/UserController";
import { useToast } from "../../controller/ToastController";

export interface LoginProps {
  loginAccount?: any;
  step?: number;
  setStep?: (step: number) => void;
  isUnion?: boolean;
  setIsUnion?: (isUnion: boolean) => void;
  carUuid?: string;
  saveAccountDataAndLogin?: (accountData: any) => void;
}

let LoginQrCheckTimeout: any;
const TestCarUuid = "123가1234";

const Login = () => {
  const [step, setStep] = useState<number>(1); // 1:대기  2:QR코드  3:사용자목록  4:공유자 여부 확인  5: 비밀번호 여부
  /*
  const [loginAccount, setLoginAccount] = useState<any>([
    {
      id: 0,
      name: "김스루",
      phone_number: "010-1234-1234",
    },
    {
      id: 1,
      name: "박스루",
      phone_number: "010-4321-4321",
    },
  ]);
  */
  const [loginAccount, setLoginAccount] = useState<any>([]);
  const [isUnion, setIsUnion] = useState<boolean>(false);
  const navigate = useNavigate();

  let oParams = useParams();
  let sCarUuid = oParams && oParams.car_uuid ? oParams.car_uuid : TestCarUuid;

  const showToast = useToast();

  /*
  const getUnionSetting = async () => {
    const accountSetting = await AsyncLocalStorage.getItem("accountSetting");
    if (accountSetting) {
      setIsUnion(accountSetting.isUnion);
      setLoginAccount(accountSetting.loginAccount);
    } else {
      //setStep(2);
    }
  };
  */

  const saveAccountDataAndLogin = async (oAccountData: any) => {
    /*
    const accountSetting = {
      isUnion: isUnion,
      loginAccount: loginAccount,
    };
    */
    AsyncLocalStorage.setItem("accountSetting", JSON.stringify(oAccountData));
    await AsyncLocalStorage.setItem("userToken", oAccountData.token.toString());
    await AsyncLocalStorage.setItem(
      "userRefreshToken",
      oAccountData.refresh_token.toString()
    );
    navigate("/home", { replace: true });
  };

  const checkLoggedInWithQr = async () => {
    clearTimeout(LoginQrCheckTimeout);
    LoginQrCheckTimeout = setTimeout(async () => {
      let oRes = await UserController.checkLoggedInWithQr({
        car_uuid: sCarUuid,
      });
      let oResData = oRes.data;
      if (oRes && oRes.status && oResData && oResData.success) {
        //console.log('oRes', oRes);
        clearTimeout(LoginQrCheckTimeout);
        if (oResData.user) {
          //setLoginAccount([oResData.user]);
        }

        if (
          oResData.user &&
          oResData.user.share_type === "single" &&
          oResData.user.use_password === 0
        ) {
          saveAccountDataAndLogin(oResData.user);
          setLoginAccount([oResData.user]);
        } else if (
          oResData.user &&
          oResData.user.share_type === "single" &&
          oResData.user.use_password === 1
        ) {
          navigate("/payment/password", {
            state: {
              passwordType: "login",
              loginAccount: JSON.stringify(oResData.user),
            },
          });
        } else if (oResData.user && oResData.user.share_type === "multi") {
          setStep(4);
        }
      } else {
        checkLoggedInWithQr();
        //showToast(`스루앱에서 로그인 필요합니다. (${sCarUuid})`, "error", 3000);
      }
    }, 3000);
  };

  const checkLoggedIn = async () => {
    let oUserData = await AsyncLocalStorage.getItem("accountSetting");
    if (oUserData && oUserData.car_uuid) {
      navigate("/home", { replace: true });
    }
  };

  useEffect(() => {
    clearTimeout(LoginQrCheckTimeout);
    //getUnionSetting();
    checkLoggedIn();
  }, []);

  useEffect(() => {
    if (step === 1) {
      checkLoggedInWithQr();
    }
  }, [step]);

  return (
    <Style>
      {step === 1 && (
        <QRCodeScreen
          loginAccount={loginAccount}
          step={step}
          setStep={setStep}
          carUuid={sCarUuid}
        />
      )}
      {step === 2 && (
        <UserList
          loginAccount={loginAccount}
          step={step}
          setStep={setStep}
          saveAccountDataAndLogin={saveAccountDataAndLogin}
        />
      )}
      {step === 4 && (
        <ShareSetting
          loginAccount={loginAccount}
          step={step}
          setStep={setStep}
          setIsUnion={setIsUnion}
          saveAccountDataAndLogin={saveAccountDataAndLogin}
        />
      )}
    </Style>
  );
};
export default Login;

const Style = styled.div`
  .wrapper {
    width: 100%;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    text-align: center;
  }
  h1.title {
    font-size: 44px;
    line-height: 104px;
    font-weight: 500;
    margin-bottom: 55px;
  }
  h2 {
    margin-top: 18px;
    font-size: 24px;
    font-weight: 500;
    line-height: 33px;
  }
  .logo {
    line-height: 100px;
    max-height: 100px;
    margin-bottom: 55px;
  }

  .listWrap {
    max-width: 100%;
    display: flex;
    padding: 0 10%;
    gap: 60px;
    overflow-x: auto;
  }
  .buttonBorder {
    min-width: 400px;
    max-width: 400px;
    min-height: 360px;
    max-height: 360px;
    padding: 3px;
    border-radius: 20px;
    background: linear-gradient(118.64deg, #dedede 2.57%, #262626 96.35%);
    button {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 10px;
      width: 100%;
      height: 100%;
      border-radius: 20px;
      background: linear-gradient(360deg, #111111 3.5%, #494949 100%);
      h1 {
        line-height: 80px;
        font-weight: 600;
      }
      h1.img {
        font-size: 56px;
        line-height: 120px;
      }
      img {
        width: 80px;
        height: 80px;
      }
    }
  }
  .buttonBorder.active {
    background: linear-gradient(281.11deg, #132756 1.98%, #ccddff 97.75%);
    button {
      background: linear-gradient(180deg, #648fe7 3.06%, #0d2a6c 97.5%);
    }
  }
`;
